import { render, staticRenderFns } from "./Verify-Email-Link.vue?vue&type=template&id=587aa746&scoped=true&"
import script from "./Verify-Email-Link.vue?vue&type=script&lang=js&"
export * from "./Verify-Email-Link.vue?vue&type=script&lang=js&"
import style0 from "./Verify-Email-Link.vue?vue&type=style&index=0&id=587aa746&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "587aa746",
  null
  
)

export default component.exports